module.exports = __webpack_public_path__ + "static/media/yesterdayImageMobile3.b53b51a5.png";